"use strict";
// generated-supplemental-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
});
exports.nodeType = 'file_generatedSupplementalTape';
exports.artifactType = 'generatedSupplementalTape';
//# sourceMappingURL=types.js.map